/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import BaseModal from 'src/common/components/Modal';
import {
	EDIT_ORDER_INPUTS,
	filterOrdersByIssue,
	formatOrders,
	formatterBodyIntegration,
} from '../utils/list_data';
import UtilInputs from 'src/common/components/UtilInputs';
import { orderOfTheDayAPI, IntegrateToOrderApi } from 'src/api/modules/orderOfTheDay';
import notice from 'src/common/components/Notice';
import { COLUMNS_RESOLUTIONS_PREVIEW, COLUMNS_TEMAS_PREVIEW } from '../utils/list_data';
import BootstrapTable from 'react-bootstrap-table-next';
import { topicAPI } from 'src/api/modules/topic';
import { startLog } from 'src/api/modules/bitacora';
import { inclusionThemesAPI } from 'src/api/modules/inclusionThemes';
import { download } from 'src/pages/Files/UpaloadFileMinos';

const DetailOrder = ({
	issue,
	order,
	isOpen,
	onClose,
	user,
	session,
	setApproval,
	setGeneralBusiness,
	setForKnowledge,
	setAddMatters,
	setOpinions,
	organoId,
	canEdit,
	isAuxiliar,
	valOrgan,
	organ = '',
	nameSesion,
	updateText,
	setUpdateText,
	sectionValidation,
}) => {
	const [inputValues, setInputValues] = useState({
		asunto: '',
		nombreTema: '',
		duracion: '',
		dentroDe: '',
		ordenamiento: '',
		titulo: '',
	});

	const [resolutionSelected, setResolutionSelected] = useState([]);
	const [issueSelected, setIssueSelected] = useState([]);
	const [isLoadingResponse, setIsLoadingResponse] = useState(false);
	const [options, setOptions] = useState([]);
	const [resolutions, setResolutions] = useState([]);
	const [issues, setIssues] = useState([]);
	const [orders, setOrders] = useState([]);
	const [respDetail, setRespDetail] = useState();
	const [loaderDown, setLoaderDown] = useState(false);

	const fetchOrderOfTheDay = React.useCallback(() => {
		orderOfTheDayAPI
			.getOrderOfTheDay(session)
			.then((response) => {
				setOrders(formatOrders(response));
				setRespDetail(response);
				let ordersItems = getOrder(response);
				setOptions(ordersItems);
			})
			.catch((e) => {
				notice(
					'Algo ha salido mal al cargar las ordenes del día, intente de nuevo'
				);
			});
	}, []);

	const getOrder = (orders) => {
		let ordersFlag = [];

		orders.forEach((item) => {
			ordersFlag.push({
				value: item.id,
				text: `${item.numeracion} ${item.nombreTema}`,
			});
			if (item.hijos.length > 0) {
				ordersFlag = ordersFlag.concat(getOrder(item.hijos));
			}
		});
		return ordersFlag;
	};

	const getTemasIncluidos = () => {
		inclusionThemesAPI
			.getIssuesBySessionId(organoId) //Se pasa id del organo por modificaciones en backend y ahora espera idorgano
			.then((response) => {
				if (response && response?.length > 0) {
					let x = response.map((c) => {
						const oficio = c.archivos.find((x) => x.tipo === 'O');
						const tarjeta = c.archivos.find((x) => x.tipo === 'T');
						const presentacion = c.archivos.find((x) => x.tipo === 'P');
						const adicional = c.archivos.find((x) => x.tipo === 'A');
						return {
							...c,
							oficio: oficio,
							tarjeta: tarjeta,
							presentacion: presentacion,
							adicional: adicional,
						};
					});
					setIssues(x);
				} else {
					setIssues([]);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};
	// Get resolutions
	const getResolutionsBySession = async () => {
		topicAPI
			.getResolutionsBySessionId(organoId)
			.then((response) => {
				if (response && response?.temas?.length > 0) {
					let x = response.temas.map((c) => {
						const oficio = c.archivos.find((x) => x.tipo === 'O');
						const tarjeta = c.archivos.find((x) => x.tipo === 'T');
						const presentacion = c.archivos.find((x) => x.tipo === 'P');
						const adicional = c.archivos.find((x) => x.tipo === 'A');
						return {
							...c,
							oficio: oficio,
							tarjeta: tarjeta,
							presentacion: presentacion,
							adicional: adicional,
						};
					});

					setResolutions(x);
				} else setResolutions([]);
			})
			.catch((e) =>
				notice('Ocurrio un error al mostrar las resoluciones asignadas', 'error')
			);
	};

	useEffect(() => {
		fetchOrderOfTheDay();
		getResolutionsBySession();
		getTemasIncluidos();
	}, [fetchOrderOfTheDay]);

	useEffect(() => {
		setInputValues({
			asunto: order.asunto,
			nombreTema: order.name,
			duracion: '',
			dentroDe: order?.father_id,
			ordenamiento: order.order,
			titulo: order.titulo,
		});
		startLog('Visualizo detalle del punto ' + order?.order + ' de ' + nameSesion);
	}, [order]);
	const checkisAvaibleNewNumber = (number, ordersArray) => {
		let isAvaible = false;
		ordersArray.forEach((x) => {
			if (x.order === number || checkisAvaibleNewNumber(number, x.subItems)) {
				isAvaible = true;
				return;
			}
		});
		return isAvaible;
	};

	const checkNumber = (number, section) => {
		let issueOrden = respDetail.filter((item) => item.asunto === section);

		let newOrder = issueOrden.filter((item) => item.numeracion === number);

		if (newOrder.length === 0) {
			let newNumeration = getNumeration(section);
			if (newNumeration !== number)
				return issueOrden.map((item) => item.numeracion).join(',');
		}

		return '';
	};

	const getLastNumber = (issue) => {
		let issueOrden = respDetail.filter((item) => item.asunto === issue);

		if (issueOrden.length === 0) {
			inputValues.ordenamiento = getNumeration(issue);
			//return getNumeration(issue);
		} else {
			let lastOrder = issueOrden[issueOrden.length - 1];
			let lastNumber = Number(lastOrder.numeracion) + 1;

			inputValues.ordenamiento = lastNumber;
			// return lastNumber;
		}
	};

	const getNumeration = (type) => {
		let numeration = 0;
		let approval = respDetail.filter((item) => item.asunto === 'PA');
		let forKnowledge = respDetail.filter((item) => item.asunto === 'PC');
		let generalBusiness = respDetail.filter((item) => item.asunto === 'AC');
		let addMatters = respDetail.filter((item) => item.asunto === 'AD');

		if (type === 'AD') {
			numeration = addMatters.length + 1;
		}
		if (type === 'PA') {
			numeration = approval.length + 1;
			numeration = numeration + addMatters.length;
		}

		if (type === 'PC') {
			numeration = forKnowledge.length + 1;
			numeration = numeration + approval.length + addMatters.length;
		}

		if (type === 'AC') {
			numeration = generalBusiness.length + 1;
			numeration =
				numeration + forKnowledge.length + approval.length + addMatters.length;
		}
		return numeration;
	};

	const editOrderOfTheDay = () => {
		let orderBranch = null;

		let numTOStr = inputValues.ordenamiento.toString();

		if (numTOStr.includes('.') === false) {
			let validation = checkNumber(inputValues.ordenamiento, inputValues.asunto);

			if (validation !== '') {
				return alert(
					'Solo puedes mover este punto dentro de la numeracion ' + validation
				);
			}
		}

		//isAuxiliar === true ? orderBranch = getNumerationAuxiliar(inputValues.asunto) : orderBranch = getNumeration(inputValues.asunto);
		const data = {
			id: order.id,
			numeracion: orderBranch !== null ? orderBranch : inputValues.ordenamiento,
			nombreTema: inputValues.nombreTema,
			//dentroDe: inputValues.dentroDe === '' ? null : inputValues.dentroDe,
			asunto: inputValues.asunto,
			estatus: 'A',
			usuarioId: user.id,
			sesionId: session,
			input: order.input,
			titulo: inputValues.titulo,
		};

		setIsLoadingResponse(true);
		orderOfTheDayAPI
			.put(order.id, data)
			.then((response) => {
				setUpdateText(false);
				setApproval(formatOrders(filterOrdersByIssue(response, 'PA')));
				setForKnowledge(formatOrders(filterOrdersByIssue(response, 'PC')));
				setGeneralBusiness(formatOrders(filterOrdersByIssue(response, 'AC')));
				setAddMatters(formatOrders(filterOrdersByIssue(response, 'AD')));
				setOpinions(formatOrders(filterOrdersByIssue(response, 'DO')));

				notice('Punto del día actualizado con éxito', 'success');
				onClose(true);

				addResolutionToOrder();
			})
			.catch((e) => {
				notice(
					e.response?.data?.mensaje != undefined
						? e.response?.data?.mensaje
						: 'Algo ha salido mal, intente otra vez',
					'warning'
				);
			})
			.finally((e) => {
				setIsLoadingResponse(false);
			});
	};

	const selectRowResolutions = {
		mode: 'checkbox',
		clickToSelect: false,
		onSelect: (row, isSelect) => {
			if (row && row.id) {
				if (!isSelect) {
					const newSelected = resolutionSelected.filter((id) => id !== row.id);
					setResolutionSelected(newSelected);
				} else {
					setResolutionSelected([...resolutionSelected, row.id]);
				}
			}
		},
	};

	const selectRowIssues = {
		mode: 'checkbox',
		clickToSelect: false,
		onSelect: (row, isSelect) => {
			if (row && row.id) {
				if (!isSelect) {
					const newSelected = issueSelected.filter((id) => id !== row.id);
					setIssueSelected(newSelected);
				} else {
					setIssueSelected([...issueSelected, row.id]);
				}
			}
		},
	};

	const addResolutionToOrder = () => {
		const data = [...resolutionSelected];
		const dataTemas = [...issueSelected];
		const body = formatterBodyIntegration(order.id, data, dataTemas);
		if (data.length === 1 && data.length > 0) {
			topicAPI
				.getResolutionsPoint(order.id)
				.then((response) => {
					if (response.temas.length === 0) {
						IntegrateToOrderApi.post(body)
							.then((response) => {
								if (response) {
									notice(`Resolución asignada con éxito`, 'success');
									onClose(true);
								}
							})
							.catch((e) => {
								notice(
									`Ha ocurrido un problema al realizar la operación, intente mas tarde`,
									'info'
								);
							});
					} else {
						notice('Ya hay una resolución asignada', 'error');
					}
				})
				.catch((e) => {
					if (e) notice('Ha ocurrido un problema con la solicitud', 'error');
				});
		} else if (data.length > 0 && data.length !== 1) {
			notice('No puedes asignar dos resoluciones', 'error');
		}
		if (dataTemas.length > 0 && dataTemas.length === 1) {
			inclusionThemesAPI
				.getIssuesByOrder(order.id)
				.then((response) => {
					if (response.length === 0) {
						IntegrateToOrderApi.post(body)
							.then((response) => {
								if (response) {
									notice(`Tema asignado con éxito`, 'success');
									onClose(true);
								}
							})
							.catch((e) => {
								notice(
									`Ha ocurrido un problema al realizar la operación, intente mas tarde`,
									'info'
								);
							});
					} else {
						notice('Ya hay un tema asignado', 'error');
					}
				})
				.catch((e) => {
					if (e) notice('Ha ocurrido un problema con la solicitud', 'error');
				});
		} else if (dataTemas.length > 0 && dataTemas.length !== 1) {
			notice('No puedes asignar dos temas', 'error');
		}
	};

	const handleChangeValues = ({ target }) => {
		const { name, value } = target;

		if (name === 'asunto') {
			getLastNumber(value);
		}

		setInputValues({ ...inputValues, [name]: value });
	};

	const onDownload = (ruta) => {
		if (ruta.ruta !== undefined) {
			download(
				ruta.ruta,
				ruta.nombre,
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
				setLoaderDown,
				'Detalle en orden del día, de la sesión ' + nameSesion
			);
		}
	};
	const disable = canEdit === false ? true : false;
	return (
		<BaseModal
			open={isOpen}
			onClose={() => {
				onClose();
				setResolutionSelected([]);
			}}
			onCancel={() => {
				onClose();
				setResolutionSelected([]);
			}}
			onConfirm={canEdit === false ? undefined : editOrderOfTheDay}
			confirmLabel={'Actualizar'}
			cancelLabel={canEdit === false ? 'Cerrar' : 'Cancelar'}
			disableOnConfirm={isLoadingResponse}
			maxWidth="lg"
			mainText={'Editar'}
		>
			<>
				<UtilInputs
					formValues={inputValues}
					onValuesChange={handleChangeValues}
					inputValues={EDIT_ORDER_INPUTS(
						options,
						disable,
						valOrgan,
						organ,
						sectionValidation
					)}
				/>
				<div className="mt-lg-5">
					<h5>
						<b>Resoluciones / Recomendaciones</b>
					</h5>
					<BootstrapTable
						caption=""
						keyField="id"
						data={resolutions}
						columns={COLUMNS_RESOLUTIONS_PREVIEW(onDownload)}
						selectRow={selectRowResolutions}
					/>
					<br></br>
					<br></br>
					<h5>
						<b>Temas</b>
					</h5>
					<BootstrapTable
						caption=""
						keyField="id"
						data={issues}
						columns={COLUMNS_TEMAS_PREVIEW(onDownload)}
						selectRow={selectRowIssues}
					/>
				</div>
			</>
		</BaseModal>
	);
};

export default DetailOrder;
